<template>
  <div>
    <div class="h-toolbarBg">
      <ejs-toolbar :items="toolbarItems"></ejs-toolbar>
        <div class='h-inputBox'>
          <ejs-textbox v-model='neName' :placeholder='$t("Topo.neName")' @keyup.enter.native="findNetList" maxLength='20'></ejs-textbox>
        </div>
    </div>
    <div class="h100-80 h-scroll">
      <ejs-grid :dataSource="netData" :allowPaging="true" ref="grid" :pageSettings="pageSettings" :height="screenHeight" :allowExcelExport='true' >
        <e-columns>
          <e-column type="checkbox" width="50" textAlign="center"></e-column>
          <e-column field="id" :visible="false"></e-column>
          <e-column field='name' :headerText='$t("Topo.neName")' width='200' textAlign='Center'></e-column>
          <e-column field='typeCode' :headerText='$t("Topo.neType")' width='200' textAlign='Center' :valueAccessor='neTypeFormatter'></e-column>
          <e-column field='equipmentName' :headerText='$t("Topo.neDev")' width='200' textAlign='Center'></e-column>
          <e-column field='equipmentIP' :headerText='$t("Topo.devIp")' width='200' textAlign='Center'></e-column>
          <e-column field='equipmentPort' :headerText='$t("Topo.devPort")' width='200' textAlign='Center'></e-column>
          <e-column field='physicalIP' :headerText='$t("Topo.physicalIP")' textAlign='Center'></e-column>
          <e-column field='physicalPort' :headerText='$t("Topo.physicalPort")' width='200' textAlign='Center'></e-column>
        </e-columns>
      </ejs-grid>
      <ejs-pager
        ref="pager"
        :pageSize="page.pageSize"
        :pageCount="page.pageCount"
        :currentPage="page.pageNo"
        :totalRecordsCount="page.totalRecordsCount"
        @click="findNetList"
      ></ejs-pager>
    </div>
    <CustomDialog ref="addNeDialog"
                  v-bind:element="addNeDialog.element"
                  v-bind:styles="addNeDialog.styles">
      <template slot="dialog-content">
        <AddNe ref="addNeDetail" @close='logHideAndfindList'>></AddNe>
      </template>
    </CustomDialog>
    <CustomDialog ref="updateNeDialog"
                  v-bind:element="updateNeDialog.element"
                  v-bind:styles="updateNeDialog.styles">
      <template slot="dialog-content">
        <UpdateNe ref="updateNeDetail" @close='logHideAndfindList'>></UpdateNe>
      </template>
    </CustomDialog>
  </div>
</template>
<script>
import CustomDialog from '../common/CustomDialog';
import AddNe from '../topoconfig/AddNe';
import UpdateNe from '../topoconfig/UpdateNe';
import {EventBus} from "../../plugins/eventBus";

export default {
    name: 'NelementList',
    components: {
      CustomDialog,
      AddNe,
      UpdateNe,
    },
    data() {
      return {
        neName:'',
        netData: [],
        toolbarItems: [
          { prefixIcon: 'icon hero-icon hero-icon-add', tooltipText: this.$t('Security.add'), click: this.showAddDialog },
          { prefixIcon: 'icon hero-icon hero-icon-edit', tooltipText: this.$t('Security.modify'), click: this.showModifyDialog },
          { prefixIcon: 'icon hero-icon hero-icon-remove', tooltipText: this.$t('Security.delete'), click: this.deleteNet },
          { prefixIcon: 'icon hero-icon hero-icon-refresh', tooltipText: this.$t('Alarm.refresh'), click: this.refreshGrid },
        ],
        neTypemap: new Map(),
        
        pageSettings: { pageSize: 15 },
        page: {
          pageCount: 1,
          totalRecordsCount: 0,
          pageNo: 1,
          pageSize: 15,
        },
        addNeDialog: {
          element: {
            target: '#app',
            isClose: true,
            refName: 'addNeDialog',
            buttonGroup: [
              {
                click: this.dialogHide,
                buttonModel: { content: `${this.$t('Common.cancel')}` }
              },
              {
                click: this.addNet,
                buttonModel: { content: `${this.$t('Common.ok')}`, cssClass: 'primary-btn' }
              }
            ],
            title: `${this.$t('Topo.neAdd')}`
          },
          styles: {
            width: '810px',
            height: '650px',
            model: true,
            visible: false
          }
        },
        updateNeDialog: {
          element: {
            target: '#app',
            isClose: true,
            refName: 'edit',
            title: `${this.$t('Topo.editNe')}`,
            buttonGroup: [
              {
                click: this.dialogHide,
                buttonModel: { content: `${this.$t('Common.cancel')}` }
              },
              {
                click: this.editNet,
                buttonModel: { content: `${this.$t('Common.ok')}`, cssClass: 'primary-btn' }
              }
            ]
          },
          styles: {
            width: '810px',
            height: '650px',
            model: true,
            visible: false
          }
        },
        screenHeight: document.body.clientHeight - 240
      }
    },
  methods: {
    refreshGrid() {
      this.findNetList();
    },
    findNetList() {
      let url = '/lte/ems/topo/ne/neList';
      const params = { params: {
        reportTaskId: this.reportTaskId,
        name: this.neName,
        pageNo: parseInt(this.page.pageNo),
        pageSize: parseInt(this.page.pageSize)
      } };
      const That = this;
      this.axios.get(url, params).then(response => {
        const result = response.data.result;
        That.netData = result;
        That.page.totalRecordsCount = response.data.totalCount;
      });
    },
    neTypeFormatter(field, nedata) {
      return this.neTypemap.get(nedata[field]);
    },
    getRecord() {
      const result = this.$refs.grid.getSelectedRecords();
      if (result === null || result === '') {
        this.$parent.showToast('warning',`${this.$t('Common.tips.noSelect')}`);
        return null;
      }
      return result;
    },
    showAddDialog() {
      this.$refs.addNeDetail.bindValidate();
      this.$refs.addNeDialog.show();
    },
    showModifyDialog() {
      const record = this.getRecord();
      if (record.length === 0) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Common.tips.selectOne')});
        return null;
      }
      if (record.length !== 1) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Common.tips.onlyOneSelect')});
        return null;
      }
      if(record.length === 1) {
          this.$refs.updateNeDialog.show();
          this.$refs.updateNeDetail.initData(record[0]);
          this.$refs.updateNeDetail.bindValidate();
      }
    },
    deleteNet() {
      const record = this.getRecord();
      if (record.length === 0) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Common.tips.selectOne')});
        return null;
      }
      if (record.length !== 1) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Common.tips.onlyOneSelect')});
        return null;
      }
      const url = '/lte/ems/topo/ne/deleteNe/'+record[0].id;
      let That = this;
      this.$layer.confirm({
        msg: `${this.$t('Common.tips.confirmTip')}`,
        btn1: {
          msg: `${this.$t('Common.cancel')}`
        },
        btn2: {
          msg: `${this.$t('Common.ok')}`,
          func: () => {
            That.axios.post(url).then(response => {
              if (response.data) {
                EventBus.$emit('toast', {type: 'success', content: this.$t('Topo.delSuccess')});
                That.findNetList();
              } else {
                EventBus.$emit('toast', {type: 'error', content: this.$t('Common.tips.failure')});
              }
            });
          }
        }
      });
    },
    addNet() {
      this.$refs.addNeDetail.outputs();
    },
    editNet() {
      this.$refs.updateNeDetail.outputs();
    },
    logHideAndfindList() {
      this.dialogHide();
      this.findNetList();
    },
    dialogHide() {
      this.$refs.addNeDialog.clear();
      this.$refs.addNeDialog.close();
      this.$refs.updateNeDialog.clear();
      this.$refs.updateNeDialog.close();
    },
    allNetTypeList() {
      let url = '/lte/ems/topo/ne/allNetTypeList';
      const That = this;
      this.axios.get(url, {}).then(response => {
        const result = response.data.resultVal;
        for(var i=0; i<result.length; i++ ){
          this.neTypemap.set(result[i].typeCode,result[i].nameKey)
        }
      });
    },
  },
  mounted() {
    this.allNetTypeList();
    this.findNetList();
  },
  watch: {
    screenHeight(val) {
      this.screenHeight = val;
    }
  }
}
</script>

